import React from 'react';

import { useTranslation } from 'src/i18n';
import { cn } from 'src/component/ds/utils';
import { Card } from 'src/component/ds/ui/card';
import { ScrollArea } from 'src/component/ds/ui/scrollArea';
import { Separator } from 'src/component/ds/ui/separator';
import { TooltipProvider } from 'src/component/ds/ui/tooltip';
import type { DeviceNavSelection } from './deviceNavState';
import DeviceNavTabs from './DeviceNavTabs';
import DeviceNavTree from './DeviceNavTree';

interface DeviceNavProps {
  selection: DeviceNavSelection;
  onSelect: (selection: DeviceNavSelection) => void;
  className?: string;
}

/*
 * The device list's sidebar: Panels | Groups | Connections, then that tab's
 * tree. The tabs stay put; only the tree scrolls.
 */
export default function DeviceNav ({ selection, onSelect, className }: DeviceNavProps) {
  const { t } = useTranslation();

  return (
    <Card
      className={cn('ds-flex ds-min-h-0 ds-w-[270px] ds-shrink-0 ds-flex-col ds-overflow-hidden ds-bg-sidebar ds-shadow-sm', className)}
    >
      <div className='ds-flex ds-flex-col ds-gap-4 ds-p-4'>
        <DeviceNavTabs value={selection.tab} onChange={(tab) => onSelect({ tab })} />
        <Separator className='ds-h-[2px]' />
      </div>
      <ScrollArea className='ds-min-h-0 ds-flex-1'>
        <TooltipProvider delayDuration={200}>
          <nav aria-label={t('deviceNav.label')} className='ds-px-4 ds-pb-4 ds-pt-1'>
            {/* Keyed by tab, so the expanded rows reset with it. */}
            <DeviceNavTree key={selection.tab} selection={selection} onSelect={onSelect} />
          </nav>
        </TooltipProvider>
      </ScrollArea>
    </Card>
  );
}
